import * as ACT from './actions'
import { createReducer } from 'redux-create-reducer'

const initialState = {
  profile: {}
}

const adminReducer = createReducer(initialState, {
  [ACT.GET_USER_FETCH_SUCCESS](state, action) {
    const { profile } = action.payload
    return {
      ...state,
      profile
    }
  },
  [ACT.SAVE_USER_FETCH_SUCCESS](state, action) {
    const { profile } = action.payload
    return {
      ...state,
      profile
    }
  },
  [ACT.UPDATE_USER_IMAGE_FETCH_SUCCESS](state, action) {
    const { profile } = action.payload
    return {
      ...state,
      profile
    }
  },
  [ACT.CHANGE_PASSWORD_FETCH_SUCCESS](state) {
    return {
      ...state
    }
  }
})

export default adminReducer
